import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { InnerTopProps } from "../types";

const InnerTop = ({ title, description }: InnerTopProps) => {
    const { gray900 } = colors;

    return (
        <div
            css={css({
                padding: "24px",

                "& > p": {
                    color: gray900,
                    fontSize: "14px",
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    wordBreak: "break-word"
                }
            })}
        >
            <p
                css={css({
                    margin: "0",
                    fontWeight: "500",

                    "& > span": {
                        fontWeight: "600"
                    }
                })}
            >
                {title}
            </p>

            {description && (
                <p
                    css={css({
                        margin: "4px 0 0"
                    })}
                >
                    {description}
                </p>
            )}
        </div>
    );
};

export { InnerTop };
